import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { NavLink } from "react-router-dom";
import Tooltip from "@/src/components/common/Elements/Tooltip/Tooltip";
import Axios from "Source/axiosPool";

@connect(store => {
    return {
        common: store.common,
        loggedUser: store.loggedUser,
        project: store.project
    }
})

class List extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            show: true,
            list: [],
            page: 1,
            lastPage: 1
        };

        _.map([ "onFetch", "onToggle", "onLoadMore","projectList" ,"handleAddProject", "onOverlay"], fn => {
            this[fn] = this[fn].bind(this);
        });
    }
    
    shouldComponentUpdate( nextProps ) {
        if( !_.isEqual( this.props.project.Inactive, nextProps.project.Inactive ) ) {
            this.setState({
                ...this.state,
                list: this.state.list.filter( p => p.id !== nextProps.project.Inactive )
            });
        }

        if( !_.isEqual( this.props.project.NewProjectAdded, nextProps.project.NewProjectAdded ) && nextProps.project.NewProjectAdded ) {
            this.onFetch();
        }

        return true;
    }

    componentDidMount() {
        this.onFetch();
    }
    componentDidUpdate(prev) {
        if(!_.isEqual(prev.project.refetch, this.props.refetch) && this.props.refetch ) {
            this.onFetch(1); 
            dispatch({ type: "SET_PROJECT_REFETCH", boolean: false });
        }
    }

    onFetch(page = 1) {
        const { dispatch, section } = this.props;
        const params = {
            page: page,
            limit: 5,
            projectType: section.id,
            listType: 'myProject'
        };

        Axios.get("api/project/getUserProject", params)
            .then(response => {
                const newList = page === 1 ? response.data.result : [...this.state.list, ...response.data.result];
                this.setState({
                    ...this.state,
                    list: newList,
                    page: response.data.count.current_page,
                    lastPage: response.data.count.last_page
                }, () => {
                    dispatch({ type: "SET_PROJECT_NEWLY_ADDED", boolean: false });
                });
            });
    }

    onToggle(e) {
        e.preventDefault();

        this.setState({
            ...this.state,
            show: this.state.show ? false : true
        })
    }

    onLoadMore(e) {
        e.preventDefault();

        this.onFetch( this.state.page + 1 );
    }

    projectList(){
        const{dispatch, section} = this.props;

        dispatch({type:'SET_PROJECT_TYPE', projectType: section.id});
        dispatch({type:'SET_PROJECT_ADD_TYPE', addType: section.id});
        dispatch({ type: "SET_PROJECT_FORM_ACTIVE", FormActive: "List" });
        dispatch({ type: "UPDATE_PROJECT_QUERY", query: "" });
    }

    handleAddProject(e){
        e.preventDefault();

        const{ dispatch, section } = this.props;

        dispatch({type:'SET_PROJECT_ADD_TYPE', addType: section.id});

        $("#addCompanyModal").modal("show");
    }

    onOverlay(e) {
        const { dispatch } = this.props;

        e.preventDefault();

        dispatch({ type: "COMMON_UPDATE_SIDEPANEL_STATUS", status: "overlay" });
    }
   
    render() {
        const { common, section, loggedUser } = this.props;

        if( common.sidepanelStatus === "icon-only" ) {
            return (
                <div class="list-icon">
                    <a href="/" onClick={this.onOverlay}   data-tooltip-id={`menu_project_item_${ section.id }`}>
                        { section.icon }
                    </a>

                    <Tooltip id={`menu_project_item_${ section.id }`} place="right" effect="solid">
                        { this.state.list.length > 1 ? section.label : section.singular }
                    </Tooltip>
                </div>
            )
        }

        return (
            <div class="accounts-list">
                <div class={`toggle-header ${this.props.project.Type === section.id && window.location.hash.indexOf("#/projects") > -1 ? "active" : ""}`}>
                    <a href="/projects" onClick={this.onToggle}>
                        { !this.state.show && <i class="material-icons">arrow_drop_down</i> }
                        { this.state.show && <i class="material-icons">arrow_drop_up</i> }
                        <h4>{ this.state.list.length > 1 ? section.label : section.singular }</h4>
                    </a>
                    {loggedUser.data.userRole < 5 && (
                        <React.Fragment>
                            <a href="/account#/projects" onClick={this.projectList}>
                                <i class="material-icons">list</i>
                            </a>
                            {(loggedUser.data.userRole < 4 || (loggedUser.data.userRole === 4 && section.id === "project")) && (
                                <a href="/account#/projects" onClick={this.handleAddProject}>
                                    <i class="material-icons">add</i>
                                </a>
                            )}
                        </React.Fragment>
                    )}
                </div>
                { this.state.show && (
                    <div class="toggle-body">
                        <div class={`toggle-container ${this.state.list.length > 5 ? "hasScroll" : ""}`}>
                            { this.state.list.map( item => (
                                <div class="account-item">
                                    <NavLink to={`/projects/${item.id}`}   data-tooltip-id={`menu_project_item_${item.id}`}>
                                        <div class="account-status" style={{ backgroundColor: item.color }}></div>
                                        <div class="account-name">
                                            <span>{ item.project.length > 22 ? `${item.project.substring(0, 22)}...` : item.project }</span>
                                        </div>
                                    </NavLink>
                                    { item.project.length > 22 && (
                                        <Tooltip id={`menu_project_item_${item.id}`} place="right" effect="solid">
                                            { item.project }
                                        </Tooltip>
                                    )}
                                </div>
                            ) ) }
                            {this.state.page < this.state.lastPage && (
                                <div class="account-more">
                                    <a href="/" onClick={this.onLoadMore}>Load More</a>
                                </div>
                            )}
                        </div>
                    </div>
                ) }
            </div>
        );
    }
}

export default List;